export const ORDERS_GRID = 'orders';
export const SHIPPINGS_GRID = 'shippings';
